import React from 'react';
import LoadingScreen from 'src/frontend-common/components/LoadingScreen';
import { useLocation } from 'react-router-dom';

const LoadingPage = () => {
  const location = useLocation();
  const setUrl = () => {
    const state = location.state as { url: string } | null;
    document.location.href = state?.url || '/';
  };

  React.useEffect(() => {
    setTimeout(setUrl, 1500);
  }, []);

  return <LoadingScreen logo variant="none" />;
};

export default LoadingPage;
